// Early childhood form - radio option hiding
function _eeccaFormVal() {
    const eecca = document.querySelector('#form_email_5595');

    function radioOptionSelect() {
        // Hide & Disable Element based on Radio Selected
        const childInEECYes = document.querySelector('#q5668_q1_0');
        const childInEECNo = document.querySelector('#q5668_q1_1');
        const childInEECWrapper = document.querySelector(
            '#sq_form_field_wrapper_q5668_q2'
        );
        const childInEECInput = document.querySelector('#q5668_q2');

        const noOfChildrenOne = document.querySelector('#q5669_q1_0');
        const noOfChildrenTwo = document.querySelector('#q5669_q1_1');
        const child2DetailsWrapper = document.querySelector('#component_5805');
        const child2DetailsInputs = document.querySelectorAll(
            '#component_5805 input'
        );

        const childAllergiesYes = document.querySelector('#q5669_q8_0');
        const childAllergiesNo = document.querySelector('#q5669_q8_1');
        const childAllergiesWrapper = document.querySelector(
            '#sq_form_field_wrapper_q5669_q9'
        );
        const childAllergiesInput = document.querySelector('#q5669_q9');

        const childDiagnosisYes = document.querySelector('#q5669_q11_0');
        const childDiagnosisNo = document.querySelector('#q5669_q11_1');
        const childDiagnosisWrapper = document.querySelector(
            '#sq_form_field_wrapper_q5669_q12'
        );
        const childDiagnosisInput = document.querySelector('#q5669_q12');

        const child2AllergiesYes = document.querySelector('#q5738_q8_0');
        const child2AllergiesNo = document.querySelector('#q5738_q8_1');
        const child2AllergiesWrapper = document.querySelector(
            '#sq_form_field_wrapper_q5738_q9'
        );
        const child2AllergiesInput = document.querySelector('#q5738_q9');

        const child2DiagnosisYes = document.querySelector('#q5738_q11_0');
        const child2DiagnosisNo = document.querySelector('#q5738_q11_1');
        const child2DiagnosisWrapper = document.querySelector(
            '#sq_form_field_wrapper_q5738_q12'
        );
        const child2DiagnosisInput = document.querySelector('#q5738_q12');

        // Child in Early Education Centre?
        if (childInEECYes) {
            childInEECYes.addEventListener('click', () => {
                childInEECWrapper.classList.remove('hide--input');
                childInEECInput.disabled = false;
            });
        }
        if (childInEECNo) {
            childInEECNo.addEventListener('click', () => {
                childInEECWrapper.classList.add('hide--input');
                childInEECInput.disabled = true;
            });
        }

        // How many children are inclided in this application?
        if (noOfChildrenOne) {
            noOfChildrenOne.addEventListener('click', () => {
                child2DetailsWrapper.classList.add('hide--input');

                for (let i = 1; i < child2DetailsInputs.length; i++) {
                    child2DetailsInputs[i].disabled = true;
                }
            });
        }
        if (noOfChildrenTwo) {
            noOfChildrenTwo.addEventListener('click', () => {
                child2DetailsWrapper.classList.remove('hide--input');

                for (let i = 1; i < child2DetailsInputs.length; i++) {
                    child2DetailsInputs[i].disabled = false;
                }
            });
        }

        // Does Child have Allergies?
        if (childAllergiesYes) {
            childAllergiesYes.addEventListener('click', () => {
                childAllergiesWrapper.classList.remove('hide--input');
                childAllergiesInput.disabled = false;
            });
        }
        if (childAllergiesNo) {
            childAllergiesNo.addEventListener('click', () => {
                childAllergiesWrapper.classList.add('hide--input');
                childAllergiesInput.disabled = true;
            });
        }

        // Does Child have Food Diagnosis?
        if (childDiagnosisYes) {
            childDiagnosisYes.addEventListener('click', () => {
                childDiagnosisWrapper.classList.remove('hide--input');
                childDiagnosisInput.disabled = false;
            });
        }
        if (childDiagnosisNo) {
            childDiagnosisNo.addEventListener('click', () => {
                childDiagnosisWrapper.classList.add('hide--input');
                childDiagnosisInput.disabled = true;
            });
        }

        // Does Child 2 have Food Allergies?
        if (child2AllergiesYes) {
            child2AllergiesYes.addEventListener('click', () => {
                child2AllergiesWrapper.classList.remove('hide--input');
                child2AllergiesInput.disabled = false;
            });
        }
        if (child2AllergiesNo) {
            child2AllergiesNo.addEventListener('click', () => {
                child2AllergiesWrapper.classList.add('hide--input');
                child2AllergiesInput.disabled = true;
            });
        }

        // Does Child 2 have Food Diagnosis?
        if (child2DiagnosisYes) {
            child2DiagnosisYes.addEventListener('click', () => {
                child2DiagnosisWrapper.classList.remove('hide--input');
                child2DiagnosisInput.disabled = false;
            });
        }
        if (child2DiagnosisNo) {
            child2DiagnosisNo.addEventListener('click', () => {
                child2DiagnosisWrapper.classList.add('hide--input');
                child2DiagnosisInput.disabled = true;
            });
        }
    }

    if (eecca) {
        radioOptionSelect();
    }
}

// damage to vehicles - radio option hiding
function _dtvFormVal() {
    const dtv = document.querySelector('#form_email_5741');
    const q5743Q3 = document.querySelector('#q5743_q3');
    const q5745Q12 = document.querySelector('#sq_form_field_wrapper_q5745_q12');

    function radioOptionSelect() {
        // Did you stop at the time of the alleged accident?
        const q5743Q2Yes = document.querySelector('#q5743_q2_0');
        const q5743Q2No = document.querySelector('#q5743_q2_1');
        const q5743Q3Wrapper = document.querySelector(
            '#sq_form_field_wrapper_q5743_q3'
        );

        // Do you agree for all correspondence to be sent to you via email?
        const q5745Q11Yes = document.querySelector('#q5745_q11_0');
        const q5745Q11No = document.querySelector('#q5745_q11_1');
        const q5745Q12Wrapper = document.querySelector(
            '#sq_form_field_wrapper_q5745_q12'
        );

        // Insurance Details
        const q5748FormQuestions = document.querySelectorAll(
            '#component_5854 .sq-form-question'
        );
        const q5748FormInputs = document.querySelectorAll(
            '#component_5854 input'
        );
        const q5748Q1Yes = document.querySelector('#q5748_q1_0');
        const q5748Q1No = document.querySelector('#q5748_q1_1');

        // Witness
        const q5749FormQuestions = document.querySelectorAll(
            '#component_5856 .sq-form-question'
        );
        const q5749FormInputs = document.querySelectorAll(
            '#component_5856 input'
        );
        const q5749Q1Yes = document.querySelector('#q5749_q1_0');
        const q5749Q1No = document.querySelector('#q5749_q1_1');

        // Authority for an Agent to Act
        const q5752FormQuestions = document.querySelectorAll(
            '#component_5862 .sq-form-question'
        );
        const q5752FormInputs = document.querySelectorAll(
            '#component_5862 input'
        );
        const q5752Q1Yes = document.querySelector('#q5752_q1_0');
        const q5752Q1No = document.querySelector('#q5752_q1_1');

        // Did you stop at the time of the alleged accident?
        if (q5743Q2Yes) {
            q5743Q2Yes.addEventListener('click', () => {
                q5743Q3Wrapper.classList.remove('hide--input');
                q5743Q3.disabled = false;
            });
        }

        if (q5743Q2No) {
            q5743Q2No.addEventListener('click', () => {
                q5743Q3Wrapper.classList.add('hide--input');
                q5743Q3.disabled = true;
            });
        }

        // Do you agree for all correspondence to be sent to you via email?
        if (q5745Q11Yes) {
            q5745Q11Yes.addEventListener('click', () => {
                q5745Q12Wrapper.classList.add('hide--input');
                q5745Q12.disabled = true;
            });
        }

        if (q5745Q11No) {
            q5745Q11No.addEventListener('click', () => {
                q5745Q12Wrapper.classList.remove('hide--input');
                q5745Q12.disabled = false;
            });
        }

        // Insurance Details
        if (q5748Q1Yes) {
            q5748Q1Yes.addEventListener('click', () => {
                for (let i = 1; i < q5748FormQuestions.length; i++) {
                    q5748FormQuestions[i].classList.remove('hide--input');
                }

                for (let j = 2; j < q5748FormInputs.length; j++) {
                    q5748FormInputs[j].disabled = false;
                }
            });
        }

        if (q5748Q1No) {
            q5748Q1No.addEventListener('click', () => {
                for (let i = 1; i < q5748FormQuestions.length; i++) {
                    q5748FormQuestions[i].classList.add('hide--input');
                }

                for (let j = 2; j < q5748FormInputs.length; j++) {
                    q5748FormInputs[j].disabled = true;
                }
            });
        }

        // Witness
        if (q5749Q1Yes) {
            q5749Q1Yes.addEventListener('click', () => {
                for (let i = 1; i < q5749FormQuestions.length; i++) {
                    q5749FormQuestions[i].classList.remove('hide--input');
                }

                for (let j = 2; j < q5749FormInputs.length; j++) {
                    q5749FormInputs[j].disabled = false;
                }
            });
        }

        if (q5749Q1No) {
            q5749Q1No.addEventListener('click', () => {
                for (let i = 1; i < q5749FormQuestions.length; i++) {
                    q5749FormQuestions[i].classList.add('hide--input');
                }

                for (let j = 2; j < q5749FormInputs.length; j++) {
                    q5749FormInputs[j].disabled = true;
                }
            });
        }

        // Authority for an Agent to Act
        if (q5752Q1Yes) {
            q5752Q1Yes.addEventListener('click', () => {
                for (let i = 1; i < q5752FormQuestions.length; i++) {
                    q5752FormQuestions[i].classList.remove('hide--input');
                }

                for (let j = 2; j < q5752FormInputs.length; j++) {
                    q5752FormInputs[j].disabled = false;
                }
            });
        }

        if (q5752Q1No) {
            q5752Q1No.addEventListener('click', () => {
                for (let i = 1; i < q5752FormQuestions.length; i++) {
                    q5752FormQuestions[i].classList.add('hide--input');
                }

                for (let j = 2; j < q5752FormInputs.length; j++) {
                    q5752FormInputs[j].disabled = true;
                }
            });
        }
    }

    if (dtv) {
        radioOptionSelect();
    }
}

_eeccaFormVal();
_dtvFormVal();

export { _eeccaFormVal, _dtvFormVal };
